module.exports = __webpack_public_path__ + "static/img/level_on.2ce6f00c.webp";